import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import config from '../../../../utils/confg.json'
import { getAllStoreSetting } from "./getAllStoreSettingSlices";
const url = config.BackendUrl;
//| 'pending' | 'succeeded' | 'failed',
const initialState = {
    response: {},
    loading: 'idle',
    httpCode: 0,
    errorMsg: "",
    errorData: {},
  };
  

  export const saveStoreSetting = createAsyncThunk(
    "saveStoreSetting/saveStoreSetting",

    async (dispatch, { rejectWithValue }) => {
      try {

        const shopId = dispatch.shopId
        const dataSaved = dispatch.dataSaved ; 

    
        const { data } = await axios.post(url + "/Apps/API/CMS/Settings/Store/save?ShopId="+shopId+"&DeviceId=0&QRKey=0" ,{...dataSaved},
          {
            withCredentials: true
          })
        return data;
      } catch (err) {

  
        if (err.response) {
          return rejectWithValue({ error: err.message, status: err.response.status, data: err.response.data });
  
  
        }
  
  
      }
    }
  );




  export const saveStoreSettingAndRestAccount = (params) => async (dispatch) => {



    await dispatch(saveStoreSetting(params))
    await dispatch(getAllStoreSetting(params))

    

  }
  



  export const saveStoreSettingSlices = createSlice({

    name: "saveStoreSetting",
    initialState,
  
    reducers: {
      reset: () => initialState
    },
    extraReducers: {
      [saveStoreSetting.pending]: (state) => {
        state.loading = 'pending';
      },
      [saveStoreSetting.fulfilled]: (state, action) => {
  
        state.loading = 'succeeded';
        state.httpCode = 200;
        state.response = action.payload;
      },
      [saveStoreSetting.rejected]: (state, action) => {
  
        try {
          state.loading = 'failed';
          state.httpCode = action.payload.status;
          state.errorMsg = action.payload.error;
          state.response = {};
          if (action.payload.status === 409) {
            state.errorData = action.payload.data
          } else {
  
            state.response = {}
  
          }
        } catch {
  
          state.httpCode = 503;
          state.errorMsg = "service unavailable";
        }
      }







  
    }
  
  })
  
  export const { reset  } = saveStoreSettingSlices.actions
  
  export default saveStoreSettingSlices.reducer;